import { render, staticRenderFns } from "./EnglishQuiz.vue?vue&type=template&id=21030602&scoped=true"
import script from "./EnglishQuiz.vue?vue&type=script&lang=js"
export * from "./EnglishQuiz.vue?vue&type=script&lang=js"
import style0 from "./EnglishQuiz.vue?vue&type=style&index=0&id=21030602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21030602",
  null
  
)

export default component.exports